<template>
    <div class="col-xs-12 text-center panel-heading quotationForm">

        <div class="row">
            <h2 v-if="quotation.date">{{ quotation.dateStr }}</h2>
        </div>
        <div class="row">
            <div class="col-md-3 col-xs-12">
                <div class="inputWrap">
                    <label for="clientName">*{{ $t('clientName') }}</label>
                    <input @change="updateQuotation" type="text" id="clientName" name="clientName" v-model="quotation.clientName" required>
                </div>
            </div>
            <div class="col-md-3 col-xs-12">
                <div class="inputWrap">
                    <label for="location">{{ $t('place') }}</label>
                    <input @change="updateQuotation" type="text" id="location" name="location" v-model="quotation.location">
                </div>
            </div>
            <div class="col-md-3 col-xs-12">
                <div class="inputWrap">
                    <label for="guests">{{ $t('brutoGuests') }}</label>
                    <input @change="updateQuotation" type="number" id="guests" name="guests" v-model="quotation.guests">
                </div>
            </div>
            <div class="col-md-3 col-xs-12">
                <div class="inputWrap">
                    <label for="requiredGuests">{{ $t('requiredGuests') }}</label>
                    <input @change="updateQuotation" type="number" id="requiredGuests" name="requiredGuests" v-model="quotation.requiredGuests">
                </div>
            </div>
            <div class="col-md-3 col-xs-12">
                <div class="inputWrap">
                    <label for="eventType_2">*{{ $t('eventType') }}</label>
                    <div class="selectWrap">
                        <select @change="updateQuotation" name="eventType_2" id="eventType_2" v-model="quotation.type" required>
                            <option value="">{{ $t('select') }}</option>
                            <option value="sitting" v-bind:selected="quotation.type == 'sitting' ? 'selected' : ''">{{ $t('type_sitting') }}</option>
                            <option value="alcohol" v-bind:selected="quotation.type == 'alcohol' ? 'selected' : ''">{{ $t('type_alcohol') }}</option>
                            <option value="eventManagement" v-bind:selected="quotation.type == 'eventManagement' ? 'selected' : ''">{{ $t('type_eventManagement') }}</option>
                            <option value="totalManage" v-bind:selected="quotation.type == 'totalManage' ? 'selected' : ''">{{ $t('type_totalManage') }}</option>
                            <option value="seatingAndAlcohol" v-bind:selected="quotation.type == 'seatingAndAlcohol' ? 'selected' : ''">{{ $t('type_seatingAndAlcohol') }}</option>
                            <option value="seatingAndManagement" v-bind:selected="quotation.type == 'seatingAndManagement' ? 'selected' : ''">{{ $t('type_seatingAndManagement') }}</option>
                        </select>
                        <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                    </div>

                </div>
            </div>
            <div class="col-md-3 col-xs-12">
                <div class="inputWrap">
                    <label for="workers">{{ $t('workersNum') }}</label>
                    <input @change="updateQuotation" type="number" id="workers" name="workers" v-model="quotation.workers">
                </div>
            </div>
            <div class="col-xs-12">
                <div class="inputWrap textareaWrap">
                    <label for="eventNotes_1">{{ $t('notes') }}</label>
                    <textarea @change="updateQuotation" name="eventNotes_1" v-model="quotation.notes" maxlength="255" id="eventNotes_1" class="noteWrapper"></textarea>
                    <span class="charsLength"><span class="charNum">{{ quotation.notes.toString().length }}</span>/255</span>
                </div>
            </div>
        </div>

        <h3>{{ $t('attachments') }}</h3>

        <div class="row actionBoxes">
            <div class="col-md-3 col-xs-12">
                <div class="inputWrap">
                    <label for="eventFiles_3">{{ $t('addFile') }}</label>
                    <div class="clearfix"></div>
                    <div class="fileInputWrap">
                        <input type="file" class="fileUploadInput" id="eventFiles_3" name="file" data-alias=".files_names" @change="uploadFile" multiple>
                        <span class="files_names" v-bind:data-placeholder="$t('addFile')" v-bind:data-limittext="$t('files')"></span>
                        <svg class="i_files" style="height: 30px;top:10px;left:10px"><use xlink:href="#i_files"></use></svg>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="matchHeight col-md-3 menuButton" v-if="typeof file ==='object'" v-for="file of quotation.files">
                <span @click="deleteFile(file.id)" class="fileDelete"><svg><use xlink:href="#i_close"></use></svg></span>
                <a :href="'https://' + $store.state.app.domain + '/api/f.php?preview=1&file=' + file.id" class="innerBox">
							<span class="svgWrap">
								<svg class="i_template"><use xlink:href="#i_files"></use></svg>
							</span>
                    <span class="linkText">
								<div class="linkTxtHeader">{{ file.fileName.toString().replace('.'+file.ext,'') }}</div>
							</span>
                    <svg class="i_linkArr"><use xlink:href="#i_linkArr"></use></svg>
                </a>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "QuotationMenu",
        props:['quotation_id'],
        data(){
            return{
                quotation:{files:[],notes:''},
            }
        },
        mounted(){
            this.getMeeting();
            niceInputFile($("input[type='file']"));
        },
        methods:{
            getMeeting(){
                this.$store.dispatch('getQuotation',this.quotation_id)
                    .then(response =>{
                        //success
                        this.quotation = response.data;
                    })
                    .catch(err => {
                        //err
                        this.$router.push('/notFound');
                    })
            },
            deleteFile(id = null){
                if(id != null){
                    this.quotation.removedFiles = this.quotation.files.filter(function(_){
                        if(_.id == id) return true;
                        return false;
                    }).map(a => a.id);
                    this.quotation.files = this.quotation.files.filter(function(_){
                        if(_.id == id) return false;
                        return true;
                    });
                    this.updateQuotation()
                }
            },
            uploadFile(){
                let formData = new FormData();
                let file = document.querySelector('.fileUploadInput');
                for(let _ in file.files) {
                    formData.append("file_" + _, file.files[_]);
                }
                this.$store.dispatch('uploadFile',formData)
                    .then(response =>{
                        //success

                        if(response.length > 0){
                            response.forEach((file)=>{
                                this.quotation.files.push(file.id);
                            });
                            this.updateQuotation();
                        }

                    })
                    .catch(err => {
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('uploadFailed'),
                            timer:3000
                        }).catch(this.$swal.noop);
                        console.warn('failed to upload file ' + err.toString());
                    })
            },
            updateQuotation(){


                this.quotation.files = this.quotation.files.map(a => (a.id ? a.id : a));

                this.$store.dispatch('updateQuotation',this.quotation)
                    .then(response =>{
                        //success
                        this.quotation = response;
                        this.quotation.date = this.quotation.dateStr;

                        niceInputFile($("input[type='file']"));
                    })
                    .catch(err => {
                        //err
                    })
            }
        }
    }
</script>

<style scoped>
    .menuButton{
        margin-top:20px
    }
    .innerBox{
        padding:0
    }


    .pieWrapper .pieInnerWrapper{
        width:50%;
        float: right;
    }

    .pieWrapper #pie-svg{
        width:50%;
        float: right;
    }

    [data-pie-id] > *:nth-child(7n+1), [data-bar-id] > *:nth-child(7n+1), [data-line-id] > *:nth-child(7n+1) {
        color: #293b5a; }
    [data-pie-id] > *:nth-child(7n+2), [data-bar-id] > *:nth-child(7n+2), [data-line-id] > *:nth-child(7n+2) {
        color: #465a7f; }
    [data-pie-id] > *:nth-child(7n+3), [data-bar-id] > *:nth-child(7n+3), [data-line-id] > *:nth-child(7n+3) {
        color: #5e769f; }
    [data-pie-id] > *:nth-child(7n+4), [data-bar-id] > *:nth-child(7n+4), [data-line-id] > *:nth-child(7n+4) {
        color: #7792bf; }



    #pie, #donut, #bar {
        max-height: 450px; }


    svg {
        width: 100%;
        height: auto;
    }


    ul[data-pie-id] {
        list-style: none;
    }
    .pieWrapper ul li{
        font-size:1.118rem;
    }
    .pieWrapper ul li + li{
        margin-top:10px;
    }
    .pieWrapper ul li span{
        color:#2e2e2e;
    }
    .pieWrapper ul li span span{
        font-weight: 700;
        font-style: italic;
    }
    .pieWrapper ul li:before{
        content: "";
        width:17px;
        height:17px;
        border-radius: 50%;
        display:inline-block;
        margin-top:2px;
        margin-left:15px;

    }
    .pieWrapper .pieInnerWrapper{
        padding:0 30px;
    }
    .pieWrapper .pieInnerWrapper h2{

        margin:20px 0px;

    }
    .pieWrapper ul li.notResponded:before{background:#5e769f;}
    .pieWrapper ul li.respondedPositive:before{background:#465a7f;}
    .pieWrapper ul li.respondedMaybe:before{background:#7792bf;}
    .pieWrapper ul li.respondedNegative:before{background:#293b5a;}

    .pieWrapper ul li.notResponded span .status{color:#5e769f;}
    .pieWrapper ul li.respondedPositive span .status{color:#465a7f;}
    .pieWrapper ul li.respondedMaybe span .status{color:#7792bf;}
    .pieWrapper ul li.respondedNegative span .status{color:#293b5a;}
    .innerMainContent {
        padding: 55px 45px;
        float: right;
        width: 100%;
    }
    .eventInfoWrapper {
        padding: 20px;
        float: right;
        width: 100%;
    }

    .imgWrap{
        width: 50%;
        float: right;
    }
    .imgWrap img{
        width:100%;
    }

    .actionBoxes .innerBox{
        width:100%;
        display:block;
        padding: 30px;
        background: #fff;
        transition: background .25s ease-in-out;
        -moz-transition: background .25s ease-in-out;
        -webkit-transition: background .25s ease-in-out;

    }
    .actionBoxes .innerBox:hover,
    .actionBoxes .innerBox:focus{
        text-decoration: none;
        transition: background .25s ease-in-out;
        -moz-transition: background .25s ease-in-out;
        -webkit-transition: background .25s ease-in-out;
        background: -moz-linear-gradient(0deg, rgba(41,59,90,1) 0%, rgba(123,150,196,1) 100%); /* ff3.6+ */
        background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(41,59,90,1)), color-stop(100%, rgba(123,150,196,1))); /* safari4+,chrome */
        background: -webkit-linear-gradient(0deg, rgba(41,59,90,1) 0%, rgba(123,150,196,1) 100%); /* safari5.1+,chrome10+ */
        background: -o-linear-gradient(0deg, rgba(41,59,90,1) 0%, rgba(123,150,196,1) 100%); /* opera 11.10+ */
        background: -ms-linear-gradient(0deg, rgba(41,59,90,1) 0%, rgba(123,150,196,1) 100%); /* ie10+ */
        background: linear-gradient(90deg, rgba(41,59,90,1) 0%, rgba(123,150,196,1) 100%); /* w3c */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#293b5a', endColorstr='#7b96c4',GradientType=1 ); /* ie6-9 */
    }
    .actionBoxes .innerBox + .innerBox{
        margin-top:45px;
    }
    .actionBoxes .innerBox .svgWrap{
        display:block;
        margin: 0 auto;
        vertical-align:middle;
        width:83px;
        height:83px;
        border-radius:50%;
        border:1px solid #80ebdf;
        background: #fff;
        text-align: center;
        margin-bottom:20px;
    }
    .actionBoxes .innerBox .svgWrap .i_users{
        width:39px;
        height:29px;
        fill:#293b5a;
        margin-top: 24px;
    }
    .actionBoxes .innerBox .svgWrap .i_template{
        width:19px;
        height:30px;
        fill:#293b5a;
        margin-top: 25px;
    }
    .actionBoxes .innerBox .linkText{
        text-align: center;
    }
    .actionBoxes .innerBox .linkText .linkTxtNum{
        color:#99aed1;
        font-size:2.412rem;
        font-weight:400;
    }
    .actionBoxes .innerBox .linkText .linkTxtHeader{
        color:#293b5a;
        font-size: 1.059rem;
        font-weight:700;
    }
    .actionBoxes .innerBox:hover .linkTxtNum,
    .actionBoxes .innerBox:focus .linkTxtNum,
    .actionBoxes .innerBox:hover .linkTxtHeader,
    .actionBoxes .innerBox:focus .linkTxtHeader{
        color:#fff;
    }
    .actionBoxes .innerBox .i_linkArr{
        display: block;
        vertical-align: middle;
        fill: #7b96c4;
        width: 38px;
        height: 38px;
        margin: 20px auto 0;
    }
    .actionBoxes .innerBox:hover .i_linkArr,
    .actionBoxes .innerBox:focus .i_linkArr{
        fill:#fff;
    }
    .matchHeight .innerBox{
        height:100%;
    }
    .actionBoxes{
        margin-top:30px;
    }
    .infoWrap{
        width:50%;
        float: right;
        text-align: center;
    }
    .infoWrap h1{
        color:#293b5a;
        font-size: 2.353rem;
        font-weight: 700;
    }
    .eventType{
        color:#87a0c9;
        font-weight: 700;
        font-style: italic;
        font-size: 1.529rem;
    }
    .eventDate{
        display: inline-block;
        padding: 15px 20px;
        position: relative;
        margin: 20px 0;
    }
    .eventDate:before,
    .eventDate:after{
        content: "";
        height:1px;
        width: 100%;
        background: #55e4d4;
        position: absolute;
        right:0;
    }
    .eventDate:before{
        bottom:100%;
    }
    .eventDate:after{
        top:100%;
    }
    .eventDate svg{
        width:29px;
        height:29px;
        fill:#293b5a;
        display: inline-block;
        vertical-align: middle;
        margin-left:10px;
    }
    .eventDate span{
        color:#293b5a;
        font-size: 1.353rem;
        display: inline-block;
        vertical-align: middle;

    }
    .eventTimeLeft{
        color:#eb001c;
        font-size: 1.176rem;
    }

</style>
